module.exports = __webpack_public_path__ + "media/images/emblems/GW-FR-Siviriez_neu-5b43f18ee01f7b21943b82cda6cdea90.png";